import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

const OPTIONS = ["Not at all", "Slightly", "Moderately", "Completely"];

export function WorkbookQuestion({ code, onDone, onClose }) {
  const [saving, setSaving] = useState(false);

  const choose = async (answer) => {
    setSaving(true);
    try {
      await api.post(`/participant/${code}/workbook`, { answer });
      onDone(answer);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-[#1E293B]/50 p-4" onClick={onClose}>
      <div className="w-full max-w-lg rounded-2xl bg-white p-8" onClick={(e) => e.stopPropagation()} data-testid="workbook-modal">
        <div className="mb-2 flex items-start justify-between">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#2563EB]">One last question</div>
          <button onClick={onClose} data-testid="workbook-close" className="rounded-full p-1 text-[#1E293B]/50 hover:bg-[#F1F5F9]"><X className="h-5 w-5" /></button>
        </div>
        <h2 className="font-display text-2xl leading-snug text-[#1E293B]">
          To what extent have you used the Workbook / Activity Book to practice the required course competencies?
        </h2>
        <div className="mt-6 grid gap-3">
          {OPTIONS.map((opt) => (
            <button
              key={opt}
              disabled={saving}
              onClick={() => choose(opt)}
              data-testid={`workbook-option-${opt.replace(/\s+/g, "-").toLowerCase()}`}
              className="rounded-xl border border-[#E2E8F0] px-5 py-3.5 text-left text-[#1E293B] transition-transform duration-200 ease-out hover:-translate-y-0.5 hover:border-[#2563EB] hover:bg-[#2563EB]/5 disabled:opacity-60"
            >
              {opt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
